
import { useEffect, useState } from 'react';
import TypeWriter from '../../components/TypeWriter';
import whatIDo from '../../constants/whatIDo';


const Home = () => {

  useEffect(() => {
    document.title = 'Jacob Acosta';
  }, []);



  return (
    <div className="App">

      <div className='min-vh-100 d-flex flex-column '>


        <div className="container px-2 justify-content-center flex-grow-1 d-flex justify-content-center align-items-center">
          <div className="col-12 py-5">
            <div className='d-flex'>
              <text className='intro-heading'>Hi, my name is </text>
            </div>
            <div className='d-flex w-100'>
              <text className='name-heading'>Jacob Acosta </text>
            </div>
            <div className='d-flex'>
              <text className='ability-heading'><TypeWriter textList={whatIDo} stayOnFirst={false}/></text>
            </div>
            <div className='d-flex w-100'>


              <text>I'm a software engineer specializing in software development.</text>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

export default Home;
